import { strategiesSelector } from "fleet/redux-store/strategies/selectors";
import { LOAD_INCIDENTS_BY_DEVICE_ID } from "fleet/redux-store/ui-state/device-incidents/actions";
import { deviceIncidentsSelector } from "fleet/redux-store/ui-state/device-incidents/selectors";
import { unloadIncidentsAction } from "fleet/redux-store/ui-state/incidents/actions";
import { connect } from "react-redux";
import { defaultObject } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { applicationsSelector } from "redux-store/applications/selectors";
import { getConnDeviceStatus } from "redux-store/connection/selectors";
import { storesReady } from "redux-store/utils";

import { DeviceOverview } from "./device-overview";

function mapStateToProps(state, props) {
  const {
    device,
    deviceId,
    deviceStatus,
    isThirdParty,
    stats,
    storesLoaded: parentStoresLoaded,
  } = props;

  const storesLoaded =
    storesReady(state.global.applications, state.app.strategies) &&
    parentStoresLoaded;

  const strategies = isThirdParty ? defaultObject : strategiesSelector(state);

  return {
    device,
    deviceId,
    deviceStatus,
    isThirdParty,
    stats,
    storesLoaded,
    strategies,
    applications: applicationsSelector(state),
    deviceStatusOnline: getConnDeviceStatus(state),
    incidents: deviceIncidentsSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadIncidentsByDeviceId: (deviceId) => {
      return createPromiseApiAction(dispatch, LOAD_INCIDENTS_BY_DEVICE_ID, [
        deviceId,
      ]);
    },
    unloadIncidents: () => {
      dispatch(unloadIncidentsAction);
    },
  };
}

const ConnectedDeviceOverview = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceOverview);

export { ConnectedDeviceOverview };
